import styled from "styled-components";

const StyledOrderValueHeader = styled.h4`
  text-align: center;
  font-weight: 700;
  color: #000639;
  margin: auto;
`;

export default StyledOrderValueHeader;
